<div *ngIf="formView === 'intro'">
  <form [formGroup]="formIntroEstimateSearch" autocomplete="off" class="contractor-search">
    <div style="margin: 12px 0;">
      <span ngStyle.lt-md="{'font-size': '14px'}" ngStyle.gt-sm="{'font-size': '16px'}"
        style="font-weight: 400;">
        I want to search for <span fxHide.lt-md>eligible</span> contractors and request estimates.
      </span>
    </div>
    <mat-form-field
      style="width: 300px; margin-right: 9px;"
      appearance="outline"
    >
      <mat-label  id="searchZIPLabel">ZIP code</mat-label>
      <input
        matInput
        placeholder="ZIP code"
        id="searchZIP"
        name="searchZIP"
        trim="blur"
        formControlName="searchZIP"
        autocomplete="postal-code"
        aria-labelledby="searchZIPLabel"
      />
      <mat-error *ngIf="formIntroEstimateSearch.get('searchZIP').errors?.required">Zip Code is required</mat-error>
      <mat-error *ngIf="formIntroEstimateSearch.get('searchZIP').errors?.pattern">Enter valid Zip code</mat-error>
    </mat-form-field>
    <mat-form-field
      style="width: 300px;"
      appearance="outline"
    >
      <mat-label>Distance</mat-label>
      <select
        matNativeControl
        formControlName="searchDistance"
      >
        <option value="">-- Select One --</option>
        <option value="5">5 miles from ZIP Code</option>
        <option value="10">10 miles from ZIP Code</option>
        <option value="25">25 miles from ZIP Code</option>
        <option value="50">50 miles from ZIP Code</option>
        <option value="100">100 miles from ZIP Code</option>
        <option value="5000">Anywhere in California</option>
      </select>
      <mat-error>Distance is required</mat-error>
    </mat-form-field>
   
    <div>
      <button
        mat-raised-button
        style="width:300px"
        color="primary" type="button"
        (click)="onSubmitFormIntroEstimateSearch()"
      >
      SEARCH ELIGIBLE CONTRACTORS
    </button>
    </div>
  </form>
  <hr class="hr-text" data-content="OR">
  <form [formGroup]="formIntroSelectSearch" autocomplete="off" class="contractor-search">
    <div style="margin: 12px 0;">
      <span ngStyle.lt-md="{'font-size': '14px'}" ngStyle.gt-sm="{'font-size': '16px'}"
        style="font-weight: 400;">
        I know the contractor who will do my retrofit.
      </span>
    </div>
    <mat-form-field
      style="width: 300px;"
      appearance="outline"
      *ngIf="this.contractorSearchFilterHide !== 'phrase'"
    >
      <mat-label>Email, Name or License</mat-label>
      <input
        matInput
        
        id="searchPhrase"
        name="searchPhrase"
        formControlName="searchPhrase"
        placeholder="Search Email, Name or License"
        autocomplete="email name license"
        aria-label="Search by Email, Name, or License 1"
      />
      <mat-error>Name, Email or License number required</mat-error>
    </mat-form-field>
    <div>
      <button
        mat-raised-button
        style="width:300px"
        color="primary" type="button"
        (click)="onSubmitFormIntroSelectSearch()"
      >
        FIND MY CONTRACTOR
      </button>
    </div>
  </form>
  <br /><br />
  <div [innerHTML]="textContractorSearchIntroduction" ></div>
</div>

<!-- search form -->
<form [formGroup]="formSearch" class="contractor-search"  autocomplete="off" *ngIf="formView === 'search'">
  <div style="margin-top: 3px;">
    <div *ngIf="this.contractorSearchFilterHide !== 'all'">

      <mat-form-field  *ngIf="!isPortal"
      style="width: 210px; margin-right: 9px;"
      
      appearance="outline"
    >
      <mat-label>Retrofit Programs</mat-label>
      <select
        matNativeControl
        formControlName="retrofitProgramsFilter" 
      >
        <option value="">-- Select One --</option>
        <option value="All">All retrofit programs</option>
        <option value="EBB">Earthquake Brace + Bolt</option>
        <option value="ESS">Earthquake Soft-Story</option>
        <option value="EMR">Earthquake Multi-Unit Retrofit</option>
          </select>
      <mat-error>Retrofit Programs is required</mat-error>
    </mat-form-field>
    <div *ngIf="!isPortal"> <br></div>
      <mat-form-field
        style="width: 130px; margin-right: 9px;"
        appearance="outline"
        *ngIf="this.contractorSearchFilterHide !== 'zip'"
      >
        <mat-label>ZIP Code</mat-label>
        <input
          matInput
          placeholder="ZIP Code"
          id="searchZIP"
          name="searchZIP"
          trim="blur"
          formControlName="searchZIP"
          autocomplete="postal-code"
          
        />
        <mat-error *ngIf="this.formSearch.get('searchZIP').invalid">{{getZipErrorMessage()}}</mat-error>
      </mat-form-field>
      <mat-form-field
        style="width: 210px;"
        appearance="outline"
        *ngIf="this.contractorSearchFilterHide !== 'zip'"
      >
        <mat-label>Distance</mat-label>
        <select
          matNativeControl
          formControlName="searchDistance"
        >
          <option value="">-- Select One --</option>
          <option value="5">5 miles from ZIP Code</option>
          <option value="10">10 miles from ZIP Code</option>
          <option value="25">25 miles from ZIP Code</option>
          <option value="50">50 miles from ZIP Code</option>
          <option value="100">100 miles from ZIP Code</option>
          <option value="5000">Anywhere in California</option>
        </select>
        <mat-error>Distance is required</mat-error>
      </mat-form-field>
      
      <button
        mat-button color="primary"
        [ngStyle.gt-xs]="{ 'margin-left': '9px' }"
        *ngIf="!this.util.isEmpty(this.contractorSearchFilterHide) && this.contractorSearchFilterHide !== 'all' && this.contractorSearchFilterHide !== 'zip'"
        (click)="onClickStartOver()"
      >
        START OVER
      </button>
      <span fxHide fxShow.gt-sm *ngIf="!this.contractorSearchFilterHide"> - OR - </span>
      <hr class="hr-text" data-content="OR" fxHide fxShow.lt-md *ngIf="!this.contractorSearchFilterHide" style="margin-bottom:20px;">
      <mat-form-field
        style="width: 250px;margin-right: 9px;"
        appearance="outline"
        *ngIf="this.contractorSearchFilterHide !== 'phrase'"
      >
        <mat-label>Email, Name or License</mat-label>
        <input
          matInput
          autocomplete="email name license"
          trim="blur"
          id="searchPhrase"
          name="searchPhrase"
          formControlName="searchPhrase"
          placeholder="Search Email, Name or License"
          aria-label="Search by Email, Name, or License 2"
          style="width: 250px;"
        />
      </mat-form-field>
<!--      
        <span  *ngIf="!isPortal" fxHide fxShow.gt-sm >Filter :</span>
        <hr  *ngIf="!isPortal" class="hr-text" data-content="Filter :" fxHide fxShow.lt-md  style="margin-bottom:20px;"> -->
       
    
      <button
        mat-button color="primary"
        [ngStyle.gt-xs]="{ 'margin-left': '9px' }"
        *ngIf="!this.util.isEmpty(this.contractorSearchFilterHide) && this.contractorSearchFilterHide !== 'all' && this.contractorSearchFilterHide !== 'name'"
        (click)="onClickStartOver()"
      >
        START OVER
      </button>
    </div>
    <div *ngIf="_openOption === 'estimate'">
      <div style="margin: 6px 0 12px 0;"  *ngIf="this.contractorSearchFilterHide">
        Choose the number of contractors to contact as well as the preferred method to receive information from contractors who are able to submit an estimate.
        You are searching for contractors within {{this.formSearch.get('searchDistance').value}} miles of {{this.formSearch.get('searchZIP').value}}. </div>
      <div>
        <mat-form-field
          ngStyle.gt-sm="{ 'margin-right': '9px' }"
          style="width: 250px;"
          appearance="outline"
          >
          <mat-label>Send request to # of contractors</mat-label>
          <select
            matNativeControl
            (change)="onCheckValidators('requestNumber')"
            (change)="onChangeCheckListToSubmit($event.target.value)"
            id="requestNumber"
            name="requestNumber"
            formControlName="requestNumber"
          >
            <option value="">-- Select One --</option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
            <option value="choice">Let me choose</option>
          </select>
        </mat-form-field>
        <mat-form-field
          style="width: 250px;"
          ngStyle.gt-sm="{ 'margin-right': '9px' }"
          appearance="outline"
        >
          <mat-label>How would you like to be contacted?</mat-label>
          <select
            matNativeControl
            (change)="onCheckValidators('requestMethod')"
            id="requestMethod"
            name="requestMethod"
            formControlName="requestMethod"
          >
            <option value="700000000">Email Address</option>
            <option value="700000001">Phone Number (On File)</option>
            <option value="700000002">Both Email and Phone</option>
          </select>
        </mat-form-field>
        <br fxHide fxShow.lt-md />
        <button
          mat-stroked-button
          color="accent"
          (click)="onClickSendRequestForEstimate()"
          [disabled]="disableSendRequest"
        >
          SEND REQUESTS
        </button>
        <button
          mat-button color="primary"
          [ngStyle.gt-xs]="{ 'margin-left': '9px' }"
          *ngIf="!this.util.isEmpty(this.contractorSearchFilterHide) && this.contractorSearchFilterHide === 'all'"
          (click)="onClickStartOver()"
        >
          START OVER
        </button>
        <br fxHide fxShow.lt-md />
        <br fxHide fxShow.lt-md />
      </div>
    </div>
  </div>
</form>

<!-- search results - pager does not work well if removed from dom, using hidden -->
<div [hidden]="formView !== 'search'">
  <div>
    <div *ngIf="waitForListingToShow">
      <mat-progress-bar value="40" mode="indeterminate"> </mat-progress-bar>
      <p>Loading contractor directory...</p>
    </div>
    <div *ngIf="_openOption !== 'estimate' && this.isPortal && !getZipErrorMessage() && !isFormIncomplete()">
      <p>Click the "SELECT" button to choose the contractor who will complete your retrofit.</p>
      <br />
    </div>
    <div *ngIf=" isFormIncomplete()">
      <p>Please enter information above to search</p>
      <br /><br />
    </div>
    <div *ngIf="!getZipErrorMessage() && !waitForListingToShow && noSearchResults && !isFormIncomplete()">
      <p>No search results</p>
      <br /><br />
    </div>
    <div class="scroll-table" width="100%"
      [hidden]="waitForListingToShow || noSearchResults || isFormIncomplete() ||dataSourceTable.data.length==0"
    >
    <div class="cea-container">
    <!-- card view -->
   <div fxLayout="row wrap" fxLayout.sm="column wrap" fxLayoutAlign="space-around stretch"  class="cardview-container">
        <div *ngFor="let item of dataSourceTable.connect()|async" fxFlex.xs="100%" fxFlex.gt-xs="100%" fxFlex.gt-sm="50%" [fxFlex.gt-md]="cardLayout">
            <mat-card class="mat-card mat-elevation-z7 card-container" >
                <div fxLayout="row wrap" fxLayoutGap="10px" fxLayoutAlign="none">
                    <div class="left-header" fxLayout="row" fxFlexAlign="left">
                        <div *ngIf="_openOption === 'estimate'" class="select-contractor" fxFlexAlign="left"  >
                            <mat-checkbox
                            (change)="selection.toggle(item)"
                            [checked]="selection.isSelected(item)"
                            [disabled]="disableSelection">
                            {{checkboxLabel(item)}}
                            </mat-checkbox>
                        </div>
                        <img class="avatar" fxFlexAlign="left"
                            [src]="getContractorImage(item)"
                            (error)="getContractorImageError($event)"
                            alt="{{item.businessName + ' logo'}}">
                        </div>
                        <mat-card-title-group    fxFlexAlign="left">
                        <mat-card-title class="mat-card-title business-name" matTooltip="{{item.businessName}}" >
                            {{ item.businessName }}
                        </mat-card-title>

                        <mat-card-subtitle class="card-subtitle mat-card-subtitle">
                            (License #:
                            <span
                                *ngIf="
                                item.contractorLicenseNumber &&
                                item.contractorLicenseNumber.length > 0;
                                else: licenseNoUnavailable
                                "
                            >
                                {{ item.contractorLicenseNumber }})
                            </span>
                            <div *ngIf="!isPortal">
                              Retrofit Programs:
                              <span>
                               {{ showRetrofitPrograms(item)}}
                              </span>
                              
                            </div>
                             
                            <ng-template #licenseNoUnavailable>
                                <span>Unavailable)</span>
                            </ng-template>
                        </mat-card-subtitle>
                    </mat-card-title-group>
                </div>
                <mat-card-content  fxHide>
                    <div (window:resize)="onResize($event)" >
                        <span>{{ this.screenWidth }}</span>
                    </div>
                </mat-card-content>
                <mat-card-content class="mat-card-content">
                    <mat-divider></mat-divider>
                </mat-card-content>
                <mat-card-content  fxLayout="column wrap">
                <div style="margin-top: 10px;">
                    <span>
                        {{ item.address2_Line1 }}, {{ !this.util.isEmpty(item.address2_Line1) ? (this.util.isEmpty(item.address2_Line2))? "" : item.address2_Line2  + ',' : '' }} {{ item.address2_City }}, {{ item.address2_StateOrProvince }}
                        {{ item.address2_PostalCode }}
                    </span>
                    <div *ngIf="item.advertiseYourself && item.advertiseYourself.length > 1" >
                    About Us: {{item.showMore ? item.advertiseYourself : (item.advertiseYourself | truncate) }}
                    <a href *ngIf="item.advertiseYourself.length > 30"
                        (click)="onToggleMoreContractor($event, item)">{{item.showMore ? 'less' : 'more' }}</a>
                    </div>
                    <div *ngIf="item.hasReview" >
                    <a href
                        (click)="onShowReviews($event, item)">Homeowner Reviews</a>
                    </div>
                </div>

                <div >
                    Email: <a target="_blank" rel="noopener" href="mailto:{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}" class="truncateLongString">{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}</a>
                </div>
                <div >
                    Phone:
                    <span *ngIf="item.address2_Telephone1 && item.address2_Telephone1.length > 0; else: phoneUnavailable">
                    {{ this.util.formatPhone(item.address2_Telephone1) }}
                    </span>
                    <ng-template #phoneUnavailable>
                    <span>Unavailable</span>
                    </ng-template>
                </div>
                <div >
                    Web:
                    <span *ngIf="item.webSiteUrl && item.webSiteUrl.length > 0; else: websiteUnavailable">
                    <a target="_blank" rel="noopener" href="{{formatLink(item.webSiteUrl)}}" class="truncateLongString">{{formatLink(item.webSiteUrl)}}</a>
                    </span>
                    <ng-template #websiteUnavailable>
                    <span>Unavailable</span>
                    </ng-template>
                </div>

            </mat-card-content>
            <mat-card-content *ngIf="_openOption !== 'estimate'">
                <mat-card-actions fxLayout="row " fxFlexAlign="right">

                    <div class="fill" fxFlexAlign="right" *ngIf="isPortal" style="text-align: right;">
                        <button
                            *ngIf="_openOption !== 'estimate'"
                            mat-stroked-button
                            color="accent"
                            (click)="onSelectContractor(item)"
                        >
                            SELECT
                        </button>
                        <div
                            *ngIf="_openOption === 'estimate'"
                            style="color: transparent;"
                        >
                            <p>REQUEST</p>
                        </div>
                    </div>
                    </mat-card-actions>
            </mat-card-content>

            </mat-card>
        </div>
    </div>

     <!-- list view -->
    <div  class="listview-container" >
      <table mat-table
    [dataSource]="dataSourceTable" style="width: 100%;"
    >
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef scope="col"> Selected </th>
        <td mat-cell width="10%" *matCellDef="let item">
          <div *ngIf="_openOption === 'estimate'" class="select-contractor" style="text-align: center;">
            <mat-checkbox
              (change)="selection.toggle(item)"
              [checked]="selection.isSelected(item)"
              [disabled]="disableSelection"
            >{{checkboxLabel(item)}}
            </mat-checkbox>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="bizLogo">
        <th mat-header-cell fxShow *matHeaderCellDef scope="col">Logo</th>
        <td mat-cell width="10%" fxShow *matCellDef="let item">
          <div style="float: left;">
            <img [src]="getContractorImage(item)"
            (error)="getContractorImageError($event)"
            alt="{{item.businessName + ' logo'}}" class="logo" />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="bizId">
        <th mat-header-cell *matHeaderCellDef scope="col"> Business Name </th>
        <td mat-cell width="35%"  style="height: 90px;" *matCellDef="let item">
          <div ngStyle.lt-md="{ 'margin-left': '9px' }">
            <div
              matTooltip="{{item.businessName}}"
              class="business-name"
            >
              {{ item.businessName }}
            </div>
            <div >
              {{ item.address2_Line1 }}, {{ !this.util.isEmpty(item.address2_Line2) ? item.address2_Line2 + ',' : '' }} {{ item.address2_City }}, {{ item.address2_StateOrProvince }}
              {{ item.address2_PostalCode }}
            </div>
            <div >
              (License #:
              <span
                *ngIf="
                  item.contractorLicenseNumber &&
                    item.contractorLicenseNumber.length > 0;
                  else: licenseNoUnavailable
                "
              >
                {{ item.contractorLicenseNumber }})
              </span>
              <ng-template #licenseNoUnavailable>
                <span>Unavailable)</span>
              </ng-template>
            </div>
            <div *ngIf="item.advertiseYourself && item.advertiseYourself.length > 1" >
              About Us: {{item.showMore ? item.advertiseYourself : (item.advertiseYourself | truncate) }}
              <a href *ngIf="item.advertiseYourself.length > 30"
                (click)="onToggleMoreContractor($event, item)">{{item.showMore ? 'less' : 'more' }}</a>
            </div>
            <div *ngIf="item.hasReview" >
              <a href
                (click)="onShowReviews($event, item)">Homeowner Reviews</a>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="bizContact">
        <th mat-header-cell *matHeaderCellDef scope="col"> Contact </th>
        <td mat-cell width="35%" *matCellDef="let item">
          <div >
            Email: <a target="_blank" rel="noopener" href="mailto:{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}">{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}</a>
          </div>
          <div >
            Phone:
            <span
              *ngIf="
                item.address2_Telephone1 &&
                  item.address2_Telephone1.length > 0;
                else: phoneUnavailable
              "
            >
            {{ this.util.formatPhone(item.address2_Telephone1) }}
            </span>
            <ng-template #phoneUnavailable>
              <span>Unavailable</span>
            </ng-template>
          </div>
          <div >
            Web:
            <span *ngIf="item.webSiteUrl && item.webSiteUrl.length > 0;  else: websiteUnavailable">
              <a target="_blank" rel="noopener" href="{{formatLink(item.webSiteUrl)}}">
                {{formatLink(item.webSiteUrl)}}</a>
            </span>
            <ng-template #websiteUnavailable>
              <span>Unavailable</span>
            </ng-template>
          </div>
        </td>
      </ng-container>
      <div *ngIf="!isPortal">
      <ng-container matColumnDef="bizRetrofitProgram" >
       
        <th mat-header-cell fxShow *matHeaderCellDef scope="col">Retrofit Programs</th>
        <td mat-cell width="25%" *matCellDef="let item">
          <span>
            {{ showRetrofitPrograms(item)}}
           </span>
      
          
          </td>
        
      </ng-container>
    </div>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef scope="col">Action</th>
        <td mat-cell width="10%" *matCellDef="let item">
          <div style="float: right;" *ngIf="isPortal">
            <button
              *ngIf="_openOption !== 'estimate'"
              mat-stroked-button
              color="accent"
              (click)="onSelectContractor(item)"
            >
              SELECT
            </button>
            <div
              *ngIf="_openOption === 'estimate'"
              style="color: transparent;"
            >
              <p>REQUEST</p>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
      <mat-paginator [hidden]="waitForListingToShow || noSearchResults || isFormIncomplete()"
        [length]="dataResultsLength"
        [pageSizeOptions]="tablePageSizeOptions"
      ></mat-paginator>
        </div>

  </div>
</div>

<!-- contractor estimates sent -->
<div style="width:100%;" *ngIf="formView === 'estimateRequested'">
  <div id="estimateRequestedPrintArea">
    <p style="margin-top: 9px;">
      Retrofit estimate requests were sent to the following {{ countSentEstimateRequests }} contractors.
    </p>
    <div class="scroll-table confirm-table">
      <table mat-table
        [dataSource]="dataSourceSentEstimateTable" style="width: 100%;"
      >
        <ng-container matColumnDef="bizSelectedIcon">
          <td class="print-hide" mat-cell style="width: 10%;" [ngStyle.lt-sm]="{'width': '1%'}" *matCellDef="let item">
            <div style="float: left;" [ngStyle.lt-sm]="{'display': 'none'}">
              <mat-icon aria-hidden="false" aria-label="done"
                style="font-size: 10px; padding:10px; text-align: center;"
                ngStyle.gt-sm="{'font-size': '50px'}">done</mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="bizId">
          <td mat-cell width="35%"  style="height: 90px;" *matCellDef="let item">
            <div ngStyle.lt-md="{ 'margin-left': '9px' }">
              <div
                matTooltip="{{item.businessName}}"
                class="business-name"
              >
                {{ item.businessName }}
              </div>
              <div>
                {{ item.address2_Line1 }}, {{ !this.util.isEmpty(item.address2_Line2) ? item.address2_Line2 + ',' : '' }} {{ item.address2_City }}, {{ item.address2_StateOrProvince }}
                {{ item.address2_PostalCode }}
              </div>
              <div>
                (License #:
                <span
                  *ngIf="
                    item.contractorLicenseNumber &&
                      item.contractorLicenseNumber.length > 0;
                    else: licenseNoUnavailable
                  "
                >
                  {{ item.contractorLicenseNumber }})
                </span>
                <ng-template #licenseNoUnavailable>
                  <span>Unavailable)</span>
                </ng-template>
              </div>
              <div *ngIf="item.advertiseYourself && item.advertiseYourself.length > 1" class="print-hide" >
                About Us: {{item.showMore ? item.advertiseYourself : (item.advertiseYourself | truncate) }}
                <a href *ngIf="item.advertiseYourself.length > 30"
                  (click)="onToggleMoreContractor($event, item)">{{item.showMore ? 'less' : 'more' }}</a>
              </div>
              <div *ngIf="item.hasReview">
                <a href
                  (click)="onShowReviews($event, item)">Homeowner Reviews</a>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="bizContact">
          <td mat-cell width="35%" *matCellDef="let item">
            <div >
              Email: <a target="_blank" rel="noopener" href="mailto:{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}" class="truncateLongString">{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}</a>
            </div>
            <div >
              Phone:
              <span
                *ngIf="
                  item.address2_Telephone1 &&
                    item.address2_Telephone1.length > 0;
                  else: phoneUnavailable
                "
              >
              {{ this.util.formatPhone(item.address2_Telephone1) }}
              </span>
              <ng-template #phoneUnavailable>
                <span>Unavailable</span>
              </ng-template>
            </div>
            <div >
              Web:
              <span *ngIf="item.webSiteUrl && item.webSiteUrl.length > 0;  else: websiteUnavailable">
                <a target="_blank" rel="noopener" href="{{formatLink(item.webSiteUrl)}}" class="truncateLongString">
                  {{formatLink(item.webSiteUrl)}}</a>
              </span>
              <ng-template #websiteUnavailable>
                <span>Unavailable</span>
              </ng-template>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="bizRetrofitProgram" >
          
          <td mat-cell width="35%" *matCellDef="let item">
            <div *ngIf="!isPortal">
              <span>
                {{ showRetrofitPrograms(item)}}
               </span>
              </div>
            </td>
          
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsComplete"></tr>
      </table>
    </div>
    <br /><br />
    <div [innerHTML]="textContractorEstimateRequested" ></div>
  </div>
  <div style="text-align: right; margin-top: 18px;">
    <button
      mat-stroked-button
      color="primary"
      style="margin-left: 9px;"
      (click)="printTable('estimateRequestedPrintArea')"
    >

      <mat-icon aria-hidden="false" aria-label="print">print</mat-icon>
      PRINT
    </button>
    <button
      mat-raised-button
      color="primary"
      style="margin-left: 9px;"
      (click)="onClickClose()"
    >
      CLOSE
    </button>
  </div>
</div>

<!-- contractor select confirm -->
<div style="width:100%;" *ngIf="formView === 'contractorSelected'">
  <p style="margin-top: 9px;">
    You have selected the following contractor to do your retrofit.
  </p>
  <div class="scroll-table confirm-table" width="100%" >
    <table mat-table
      [dataSource]="dataSourceSelectedContractorTable" style="width: 100%;"
    >
      <ng-container matColumnDef="bizSelectedIcon">
        <td class="print-hide" mat-cell style="width: 10%;" [ngStyle.lt-sm]="{'width': '1%'}" *matCellDef="let item">
          <div style="float: left;" [ngStyle.lt-sm]="{'display': 'none'}">
            <mat-icon aria-hidden="false" aria-label="done"
            style="font-size: 10px; padding:10px; text-align: center;"
            ngStyle.gt-sm="{'font-size': '50px'}">done</mat-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="bizId">
        <td mat-cell width="35%"  style="height: 90px;" *matCellDef="let item">
          <div ngStyle.lt-md="{ 'margin-left': '9px' }">
            <div
              matTooltip="{{item.businessName}}"
              class="business-name"
            >
              {{ item.businessName }}
            </div>
            <div >
              {{ item.address2_Line1 }}, {{ !this.util.isEmpty(item.address2_Line2) ? item.address2_Line2 + ',' : '' }} {{ item.address2_City }}, {{ item.address2_StateOrProvince }}
              {{ item.address2_PostalCode }}
            </div>
            <div >
              (License #:
              <span
                *ngIf="
                  item.contractorLicenseNumber &&
                    item.contractorLicenseNumber.length > 0;
                  else: licenseNoUnavailable
                "
              >
                {{ item.contractorLicenseNumber }})
              </span>
              <ng-template #licenseNoUnavailable>
                <span>Unavailable)</span>
              </ng-template>
            </div>
            <div *ngIf="item.advertiseYourself && item.advertiseYourself.length > 1" class="print-hide" >
              About Us: {{item.showMore ? item.advertiseYourself : (item.advertiseYourself | truncate) }}
              <a href *ngIf="item.advertiseYourself.length > 30"
                (click)="onToggleMoreContractor($event, item)">{{item.showMore ? 'less' : 'more' }}</a>
            </div>
            <div *ngIf="item.hasReview" >
              <a href
                (click)="onShowReviews($event, item)">Homeowner Reviews</a>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="bizContact">
        <td mat-cell width="35%" *matCellDef="let item">
          <div>
            Email: <a target="_blank" rel="noopener" href="mailto:{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}">{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}</a>
          </div>
          <div >
            Phone:
            <span
              *ngIf="
                item.address2_Telephone1 &&
                  item.address2_Telephone1.length > 0;
                else: phoneUnavailable
              "
            >
            {{ this.util.formatPhone(item.address2_Telephone1) }}
            </span>
            <ng-template #phoneUnavailable>
              <span>Unavailable</span>
            </ng-template>
          </div>
          <div >
            Web:
            <span *ngIf="item.webSiteUrl && item.webSiteUrl.length > 0;  else: websiteUnavailable">
              <a target="_blank" rel="noopener" href="{{formatLink(item.webSiteUrl)}}">
                {{formatLink(item.webSiteUrl)}}</a>
            </span>
            <ng-template #websiteUnavailable>
              <span>Unavailable</span>
            </ng-template>
          </div>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="bizRetrofitProgram" >
       
        <td mat-cell width="35%" *matCellDef="let item">
          <div *ngIf="!isPortal">
          <div  *ngIf="item.contractorInDirectory === true">
          EBB
          </div>
          <div  *ngIf="item.essContractorInDirectory === true">
            ESS
            </div>
          </div>
          </td>
        
      </ng-container> -->
      <tr mat-row *matRowDef="let row; columns: displayedColumnsComplete"></tr>
    </table>
  </div>
  <form [formGroup]="formConfirmContractor" autocomplete="off">
    <div style="margin: 18px 9px;">
      <mat-checkbox
        name="requestEstimate"
        id="requestEstimate"
        formControlName="requestEstimate"
      >Request an estimate from this contractor
      </mat-checkbox>
    </div>
    <button
      mat-raised-button
      color="primary"
      style="margin-left: 9px; margin-top: 9px;"
      (click)="onSelectContractorConfirm()"
    >
      CONFIRM SELECTION
    </button>
    <button
      mat-stroked-button
      color="primary"
      style="margin-left: 9px; margin-top: 9px;"
      (click)="onClickReturnToSearch()"
    >
      CANCEL AND CONTINUE SEARCHING
    </button>
  </form>
</div>
